import React from "react";
import Teamcarousel from './teamcarousel/Teamcarousel';
import Freistellungsbescheid from '../../media/about/Freistellungsbescheid 2023.pdf';
import Satzung from '../../media/about/2021-11-30 Satzung Afrika-Link - Gr�ndung 3.0.pdf'; // filename has corrupted ü
import Broschuere from '../../media/about/broschuere-afrika-link-6.0.pdf';
import './About.css';

const About = () => {
    return (
        <>
            {/* Vision */}
            <section className="section section-light">
                <div className="container">
                    <div className="section-grid">
                        <div className="section-label">
                            <p className="label-sub">Wer wir sind</p>
                            <h2>Unsere Vision</h2>
                        </div>
                        <div className="section-body">
                            <p>
                                Afrika-Link steht für eine Verbindung zwischen Europa und Afrika – eine Brücke, die
                                Austausch und Zusammenarbeit ermöglicht. Gegründet von Peter Link, verkörpert der Verein
                                die Idee, Menschen und Kulturen näherzubringen.
                            </p>
                            <p>
                                Unser Fokus liegt darauf, Wissen und Ressourcen zu teilen, um gegenseitigen Nutzen zu
                                schaffen und eine nachhaltige Entwicklung zu fördern – insbesondere in Tansania. So
                                möchten wir dazu beitragen, dass beide Kontinente voneinander lernen und wachsen können.
                            </p>
                            <p>
                                Weitere Informationen finden Sie in unserer{' '}
                                <a className="about-link" href={Broschuere} target="_blank" rel="noreferrer">
                                    Broschüre
                                </a>.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Quote */}
            <section className="about-quote-band">
                <blockquote>
                    <p>„Hilf mir, es allein zu tun."</p>
                    <cite>— Maria Montessori</cite>
                </blockquote>
            </section>

            {/* Transparency */}
            <section className="section section-sand">
                <div className="container">
                    <div className="section-grid">
                        <div className="section-label">
                            <p className="label-sub">Offenheit</p>
                            <h2>Transparenz</h2>
                        </div>
                        <div className="section-body">
                            <p>
                                Um unsere Arbeit für Unterstützerinnen und Unterstützer transparent zu gestalten,
                                finden Sie hier unsere Satzung sowie den aktuellen Freistellungsbescheid:
                            </p>
                            <ul className="about-doc-list">
                                <li><a className="about-link" href={Satzung} target="_blank" rel="noreferrer">Satzung</a></li>
                                <li><a className="about-link" href={Freistellungsbescheid} target="_blank" rel="noreferrer">Freistellungsbescheid 2023</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Team carousel */}
            <section className="section section-light" id="team-section">
                <div className="container">
                    <div className="team-header">
                        <p className="label-sub">Die Menschen dahinter</p>
                        <h2 className="team-heading">Unser Team</h2>
                    </div>
                    <Teamcarousel />
                </div>
            </section>

            {/* Contact */}
            <section className="about-contact-band" id="contact-section">
                <div className="container">
                    <div className="section-grid">
                        <div className="section-label">
                            <p className="label-sub" style={{ color: '#E8C547' }}>Schreiben Sie uns</p>
                            <h2 style={{ color: 'white' }}>Kontakt</h2>
                        </div>
                        <div className="contact-body">
                            <div className="contact-block">
                                <span className="contact-label">Telefon</span>
                                <span>+4916090800222</span>
                            </div>
                            <div className="contact-block">
                                <span className="contact-label">E-Mail</span>
                                <a className="contact-link" href="mailto:info@afrika-link.org">info@afrika-link.org</a>
                            </div>
                            <div className="contact-block">
                                <span className="contact-label">Adresse</span>
                                <address>
                                    Afrika-Link e.V.<br />
                                    Geschäftsstelle Helmstedt<br />
                                    Collegienstraße 3a<br />
                                    38350 Helmstedt
                                </address>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="about-photo-footer"></div>
        </>
    );
};

export default About;
